import { Observable, Subject } from 'rxjs'
import { StandOperationResult } from '../../entities/standOperationResult'
import { V14Operation, isV14OperationCancelledException } from './v14Operation'

export class V14TimeoutController {
  private readonly ackTimeout: number
  private readonly resultTimeout: number
  private readonly resultsSubject = new Subject<StandOperationResult>()
  private currentOperation: V14Operation | null = null
  private closed = false

  constructor(
    options: { ackTimeoutMs?: number; resultTimeoutMs?: number } = {}
  ) {
    this.ackTimeout = options.ackTimeoutMs ?? 3000
    this.resultTimeout = options.resultTimeoutMs ?? 15000
  }

  get results$(): Observable<StandOperationResult> {
    return this.resultsSubject.asObservable()
  }

  onWriteIssued(): void {
    this.currentOperation?.cancel()
    const operation = new V14Operation({
      ackTimeoutMs: this.ackTimeout,
      resultTimeoutMs: this.resultTimeout,
    })
    this.currentOperation = operation
    operation.waitForResult().then(
      (result) => {
        if (!this.closed && this.currentOperation === operation) {
          this.resultsSubject.next(result)
        }
      },
      (error) => {
        if (this.closed) return
        if (isV14OperationCancelledException(error)) return
        if (this.currentOperation !== operation) return
        // RxJS Subject は error() で終端する。closed を立てて内部状態を
        // 「結果ストリーム終端済み」に揃える（error 後に doomed な operation を
        // 作らせない）。なお error 後の再送で結果が届かない挙動自体は Subject の
        // 仕様であり、本質的な解消は repository 側の「error 後は disconnect して
        // 新しい接続/controller で再送する」契約に委ねる。
        this.closed = true
        this.resultsSubject.error(error)
      }
    )
  }

  onAckReceived(): void {
    this.currentOperation?.onAckReceived()
  }

  onResultReceived(result: StandOperationResult): void {
    this.currentOperation?.onResultReceived(result)
  }

  onDisconnect(): void {
    this.currentOperation?.cancel()
    this.currentOperation = null
    if (!this.closed) {
      this.closed = true
      this.resultsSubject.complete()
    }
  }
}
